import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';
import {FileManager} from '../../shared/Models/FileManager';

@Injectable()
export class DownloadService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public getDownloads(gridData = new HttpParams(), scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/download/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public deleteDownload(id, scope = 'backoffice') {
    return this.http.delete(environment.apiUrl + '/' + scope + '/download/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getDownloadItem(downloadId, scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/download/' + downloadId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public manageDownload(download, isEdit, id = null, scope = 'backoffice') {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/' + scope + '/download/' + id, download)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/' + scope + '/download/', download)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getUserRoles(scope = 'backoffice') {
    return this.http.get<any>(environment.apiUrl + '/' + scope + '/account/roles')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setPosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/download/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public setFilePosition(position, id = null) {
    return this.http.put(environment.apiUrl + '/backoffice/download/files/' + id + '/change-position', position)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public downloadFile(fileType: FileManager) {
    return this.http.get(environment.apiUrl + `/download?path=${fileType.path}&filename=${fileType.filename}`, {
      responseType: 'arraybuffer' as 'json',
      observe: 'response'
    }).pipe(
      map((resp: HttpResponse<ArrayBuffer>) => this.helper.fileDownloadMap(resp))
    ).pipe(catchError(res => this.helper.catchError(res)));
  }
}
